<template>
	<div>
		<header :style="isMobile() ? 'padding:7px 25px':''">
			<div class="row">
				<div style="max-width:160px;" :class="isMobile() ? 'mx-auto':'ml-4'" :style="isMobile() ? '':'width:16%;'">
					<router-link to="/" exact>  
						<a href="/">
							<img id="logoImage" style="max-width:128px;max-height:40px;" src="/koreyomo/static/assets/images/mai_part-01.png">
						</a>
					</router-link>
				</div>
				<div v-if="!isMobile()" style="width:80%;height: 31px; color:#FFF;padding-top:5px;padding-left:15px;">
					読後の感情を認識するマンガ人工知能『MAI』が、あなたの読みたいマンガをおすすめします。
				</div>
			</div>
		</header>
	</div>
</template>

<script>
	export default {
		name: 'Header',
		// created(){
		// 	$(document).ready(function() {
		// 		var referrer =  document.referrer;
		// 		console.log(referrer);
		// 	});
		// },
		// beforeRouteEnter(to, from, next) {
		// 	alert(to);
		// },
	}
</script>
<style>
	
</style>



// WEBPACK FOOTER //
// src/components/Header.vue